
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/charity/[charitySlug]",
      function () {
        return require("private-next-pages/charity/[charitySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/charity/[charitySlug]"])
      });
    }
  